const productTypesMap = {
  existing: 'existing',
  custom: 'custom',
}
export default productTypesMap
